{
	"title": "Gestionar declaraciones",
	"createDeclaration": "Crear declaración"
}
